import React from "react"
import StatusPill from "../../../shared/components/StatusPill"
import { ui } from "../../../shared/styles/uiSystem"
import { buttonStyle } from "./ClinicalHistoryStyles"
import { SummaryTile } from "./ClinicalHistoryUiBlocks"

export default function ClinicalHistoryBaseEditorLayout({
  patientDisplayName,
  isFormDirty,
  isReadOnly,
  readOnlyReason,
  saving,
  onBackToSummary,
  children,
}) {
  const editorStatus = isReadOnly
    ? { tone: "danger", label: readOnlyReason || "Solo lectura" }
    : saving
      ? { tone: "warning", label: "Guardando..." }
      : isFormDirty
        ? { tone: "warning", label: "Cambios pendientes" }
        : { tone: "success", label: "Al día" }

  return (
    <div
      style={{
        display: "grid",
        gap: 18,
        alignContent: "start",
      }}
    >
      <div
        style={{
          ...ui.card,
          borderRadius: 22,
          padding: 16,
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "minmax(0, 1fr) minmax(280px, 420px)",
            gap: 14,
            alignItems: "end",
          }}
        >
          <div
            style={{
              display: "grid",
              gap: 8,
              alignContent: "start",
              minWidth: 0,
            }}
          >
            <div
              style={{
                fontSize: 11,
                fontWeight: 900,
                textTransform: "uppercase",
                letterSpacing: 0.6,
                color: "#64748b",
              }}
            >
              Editor clínico
            </div>

            <div
              style={{
                display: "flex",
                gap: 10,
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <div
                style={{
                  fontSize: 28,
                  fontWeight: 900,
                  color: "#0f172a",
                  lineHeight: 1.02,
                  letterSpacing: "-0.03em",
                  wordBreak: "break-word",
                }}
              >
                Historia base general
              </div>

              <StatusPill tone={editorStatus.tone}>{editorStatus.label}</StatusPill>
            </div>

            <div
              style={{
                fontSize: 13,
                color: "#64748b",
                lineHeight: 1.45,
                maxWidth: 760,
              }}
            >
              Estás editando el expediente clínico general de{" "}
              <strong>{patientDisplayName}</strong>. Aquí se consolida la historia
              clínica base del paciente.
            </div>
          </div>

          <div
            style={{
              display: "grid",
              gap: 10,
              alignContent: "start",
              minWidth: 0,
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                gap: 10,
              }}
            >
              <SummaryTile
                title="Modo"
                value="Historia base"
                subtitle="Editor principal del expediente"
                tone="info"
              />

              <SummaryTile
                title="Cambios"
                value={isFormDirty ? "Pendientes" : "Al día"}
                subtitle={
                  isFormDirty
                    ? "Hay modificaciones todavía sin consolidar"
                    : "Sin cambios pendientes"
                }
                tone={isFormDirty ? "warning" : "success"}
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 8,
                flexWrap: "wrap",
              }}
            >
              <button onClick={onBackToSummary} style={buttonStyle}>
                Volver al resumen
              </button>
            </div>
          </div>
        </div>
      </div>

      {children}
    </div>
  )
}